module.exports = __webpack_public_path__ + "static/media/icon-alert.278fccbf.svg";